(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npImage', function () {
        return {
            restrict: 'E',
            scope: {
                model: '=npImageModel'
            },
            templateUrl: paths.ImageView,
            replace: true,
            link: link
        };
    });

    function link(scope, element, attrs) {
        var model = scope.model,
            image = angular.element('<img>')
                .attr('src', handbookRequests.GetImageRequest + model.imageId)
                .attr('align', 'left')
                .attr('alt', model.caption)
                .css('width', '100%')
                .addClass('np-image__image');

        if (model.url) {
            image = angular.element('<a>')
                .attr({
                    href: model.url,
                    target: model.openInNewWindow ? '_blank' : '_self',
                    title: model.caption
                })
                .append(image);
        }

        element
            .css('width', getWidth(model))
            .addClass(getImageClass(model))
            .prepend(image);
    }

    function getImageClass(image) {
        var horizontalAlign = "";
        switch (parseInt(image.horizontalAlign)) {
            case parseInt(E.HorizontalAlign.Right):
                horizontalAlign = "ImageRight";
                break;
            case parseInt(E.HorizontalAlign.Left):
                horizontalAlign = "ImageLeft";
                break;
            case parseInt(E.HorizontalAlign.Center):
                horizontalAlign = "ImageMid";
                break;
        }
        return horizontalAlign;
    }

    function getWidth(image) {
        var width;

        if (image.scaleDir != 0)
            if (image.scaleDir == 1) {
                width = image.size;
            }
            else {
                width = image.size / image.height * image.width;
            }
        else {
            width = image.width;
        }

        return width;
    }

})();